var map = {
	"./Anyswap.png": 545,
	"./Anyswap.svg": 546,
	"./AppOrder-ball.png": 321,
	"./Artwork.svg": 547,
	"./Artwork_gmx.svg": 548,
	"./Banxa.png": 549,
	"./C1.png": 322,
	"./C2.png": 323,
	"./C3.png": 324,
	"./C4.png": 325,
	"./C5.png": 326,
	"./C6.png": 327,
	"./Coinbase.png": 328,
	"./Copy.png": 143,
	"./DROP_DOWN.svg": 329,
	"./Download.png": 330,
	"./FaChevronDown.svg": 260,
	"./Group1615.png": 550,
	"./Hop.png": 551,
	"./Hop.svg": 552,
	"./Hop_dark.png": 553,
	"./Hop_dark.svg": 554,
	"./Increase.png": 331,
	"./Mark.png": 207,
	"./MetaMasks.png": 332,
	"./SafePal.png": 333,
	"./SwitchOver.png": 334,
	"./Synapse.png": 555,
	"./Synapse.svg": 556,
	"./TokenPocket.png": 335,
	"./TrustWallet.png": 336,
	"./Vector.png": 337,
	"./WalletConnect.png": 338,
	"./arrow.png": 210,
	"./avt-logo-with-name.svg": 339,
	"./avt-logo.svg": 173,
	"./avt_logo.svg": 557,
	"./bannerBr.png": 558,
	"./bigBannerBr.png": 559,
	"./binance.png": 560,
	"./bscscan.png": 561,
	"./btn_big_arbitrum.png": 562,
	"./btn_big_avalanche.png": 563,
	"./btn_big_bsc.png": 564,
	"./btn_big_purchasegmx.png": 565,
	"./btn_big_purchasegmx.svg": 566,
	"./buy_gmx.svg": 340,
	"./buy_gmx_bond.svg": 567,
	"./buy_transfer_eth.svg": 568,
	"./card1.png": 569,
	"./card2.png": 570,
	"./card3.png": 571,
	"./card4.png": 572,
	"./cardBr.png": 573,
	"./cardBr1.png": 574,
	"./centerBr.png": 575,
	"./centerBr1.png": 576,
	"./centerImg.png": 577,
	"./centerImg1.png": 578,
	"./coingecko.png": 579,
	"./correct.png": 189,
	"./cross.svg": 580,
	"./discord_line.svg": 174,
	"./flag_en.svg": 581,
	"./flag_es.svg": 582,
	"./flag_fr.svg": 583,
	"./flag_ja.svg": 584,
	"./flag_ko.svg": 585,
	"./flag_ru.svg": 586,
	"./flag_zh.svg": 587,
	"./footer-Logo.svg": 341,
	"./footer-br.png": 588,
	"./footerBr.png": 589,
	"./frame.svg": 211,
	"./glp_icon.svg": 590,
	"./gmx-logo-final-white-small.png": 591,
	"./gmx-logo-final-white.png": 592,
	"./gmx-logo-final.png": 593,
	"./gmx-logo-glow.png": 594,
	"./gmx_logo.svg": 595,
	"./graphite-01.png": 596,
	"./home-smallBanner.png": 342,
	"./ic-communityproject.svg": 597,
	"./ic_alp_24.svg": 273,
	"./ic_alp_40_1.svg": 212,
	"./ic_arbitrum_16.svg": 150,
	"./ic_arbitrum_24.svg": 213,
	"./ic_arbitrum_40.png": 598,
	"./ic_arbitrum_40.svg": 599,
	"./ic_arbitrum_96.svg": 175,
	"./ic_arbitrum_hover_16.svg": 600,
	"./ic_arrowleft16.svg": 601,
	"./ic_arrowright16.svg": 602,
	"./ic_avalanche_16.svg": 151,
	"./ic_avalanche_24.svg": 214,
	"./ic_avalanche_96.svg": 176,
	"./ic_avax_24.svg": 603,
	"./ic_avax_30.svg": 343,
	"./ic_avax_40.svg": 604,
	"./ic_avt_40_1.svg": 177,
	"./ic_banxa.svg": 274,
	"./ic_binance_logo.svg": 275,
	"./ic_bsc.svg": 605,
	"./ic_bsc_40.png": 606,
	"./ic_bsc_96.svg": 607,
	"./ic_btc.b_24.svg": 608,
	"./ic_btc.b_40.svg": 609,
	"./ic_btc_24.png": 610,
	"./ic_btc_24.svg": 611,
	"./ic_btc_40.svg": 612,
	"./ic_busd_24.svg": 613,
	"./ic_buy_glp.svg": 344,
	"./ic_cash.png": 614,
	"./ic_cash.svg": 615,
	"./ic_checked.svg": 345,
	"./ic_coingecko_16.svg": 405,
	"./ic_coingecko_hover_16.svg": 616,
	"./ic_convert_down.svg": 617,
	"./ic_copy_16.svg": 261,
	"./ic_cost.svg": 346,
	"./ic_dai_24.svg": 618,
	"./ic_dai_40.svg": 619,
	"./ic_discord.svg": 620,
	"./ic_eth_24.png": 621,
	"./ic_eth_24.svg": 347,
	"./ic_eth_40.svg": 622,
	"./ic_ethereum_40.png": 623,
	"./ic_fantom.svg": 406,
	"./ic_fantom_40.png": 624,
	"./ic_frax_24.svg": 625,
	"./ic_frax_40.svg": 626,
	"./ic_ftm_24.svg": 627,
	"./ic_ftm_40.svg": 628,
	"./ic_github-1.svg": 629,
	"./ic_github.svg": 630,
	"./ic_glp_40.svg": 631,
	"./ic_glp_custom.svg": 348,
	"./ic_gmx.svg": 632,
	"./ic_gmx_24.svg": 633,
	"./ic_gmx_30.svg": 634,
	"./ic_gmx_40.svg": 635,
	"./ic_gmx_64.svg": 636,
	"./ic_gmx_arbitrum.svg": 349,
	"./ic_gmx_avax.svg": 350,
	"./ic_gmx_big.svg": 637,
	"./ic_gmx_custom.svg": 351,
	"./ic_gmx_footer.svg": 638,
	"./ic_hop.svg": 352,
	"./ic_info.svg": 639,
	"./ic_language24.svg": 276,
	"./ic_link_24.svg": 640,
	"./ic_link_40.svg": 641,
	"./ic_liquidity.svg": 353,
	"./ic_medium-1.svg": 642,
	"./ic_medium.svg": 643,
	"./ic_menu_dots.svg": 644,
	"./ic_metamask.png": 190,
	"./ic_metamask_16.svg": 354,
	"./ic_metamask_hover_16.svg": 645,
	"./ic_mim_24.svg": 646,
	"./ic_mim_40.svg": 647,
	"./ic_multiswap.svg": 277,
	"./ic_new_link_16.svg": 262,
	"./ic_olympus.svg": 648,
	"./ic_olympus_arbitrum.svg": 355,
	"./ic_optimism-1.svg": 649,
	"./ic_optimism.svg": 178,
	"./ic_optimism_40.png": 650,
	"./ic_polygon_40.png": 651,
	"./ic_selector_dropdowns.svg": 652,
	"./ic_settings_16.svg": 278,
	"./ic_settings_24.svg": 653,
	"./ic_sign in_16.svg": 654,
	"./ic_sign_out_16.svg": 263,
	"./ic_simpleswaps.svg": 356,
	"./ic_stats.svg": 357,
	"./ic_stats_big.svg": 655,
	"./ic_synapse.svg": 279,
	"./ic_telegram-1.svg": 656,
	"./ic_telegram.svg": 657,
	"./ic_tether_24.svg": 658,
	"./ic_tokens.svg": 659,
	"./ic_totaluser.svg": 358,
	"./ic_trading.svg": 359,
	"./ic_transfer_avax.svg": 660,
	"./ic_twitter-1.svg": 661,
	"./ic_twitter.svg": 662,
	"./ic_uni_24.svg": 663,
	"./ic_uni_40.svg": 664,
	"./ic_usdc.e_24.svg": 665,
	"./ic_usdc.e_40.svg": 666,
	"./ic_usdc_24.svg": 667,
	"./ic_usdc_40.svg": 668,
	"./ic_usdt_24.svg": 669,
	"./ic_usdt_40.svg": 670,
	"./ic_wallet_24.svg": 671,
	"./ic_wallet_25.svg": 169,
	"./ic_wavax_24.svg": 672,
	"./ic_wavax_40.svg": 673,
	"./ic_wbtc_24.svg": 674,
	"./ic_wbtc_40.svg": 675,
	"./ic_weth_24.svg": 676,
	"./ic_weth_40.svg": 677,
	"./ic_wftm_24.svg": 678,
	"./ic_wftm_40.svg": 679,
	"./lan.svg": 360,
	"./lg_arbitrum.svg": 680,
	"./loading.svg": 159,
	"./logo_GMX.svg": 681,
	"./logo_GMX_small.svg": 682,
	"./long.png": 683,
	"./long.svg": 361,
	"./long_active.svg": 362,
	"./medium-line.svg": 179,
	"./medium.svg": 684,
	"./medium_line.png": 685,
	"./metamask-text.svg": 686,
	"./metamask1.png": 687,
	"./page-not-found.svg": 688,
	"./position-share-bg.png": 363,
	"./safePal.jpg": 689,
	"./safepalImg.png": 690,
	"./short.png": 691,
	"./short.svg": 364,
	"./short_active.svg": 365,
	"./small-logo-1.png": 692,
	"./small-logo.png": 693,
	"./smallBannerBg.png": 694,
	"./small_Frame.svg": 215,
	"./small_discord_line.svg": 216,
	"./small_medium.svg": 217,
	"./small_twitter_line.svg": 218,
	"./small_youtube_line.svg": 219,
	"./smalltelegram_line.svg": 220,
	"./swap.png": 695,
	"./swap.svg": 366,
	"./swap_active.svg": 696,
	"./swap_active1.svg": 367,
	"./telegram_line.svg": 180,
	"./tp.jpg": 697,
	"./trading.jpg": 698,
	"./trust.jpg": 699,
	"./trustImg.png": 700,
	"./twitter_line.svg": 181,
	"./wallet-connect-text.svg": 701,
	"./walletconnect-circle-blue.svg": 702,
	"./watch.png": 368,
	"./wave-01.png": 703,
	"./wave-02.png": 704,
	"./youtube_line.svg": 221
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 544;